import type { TGalleryMediaCategory } from '../utils/conversationMediaGallery';

export type TMediaGalleryTab = 'all' | TGalleryMediaCategory;

export const MEDIA_GALLERY_DEFAULT_LIMIT = 100;
export const MEDIA_GALLERY_PREVIEW_LIMIT = 4;
export const MEDIA_GALLERY_SKELETON_COUNT = 8;

const MIME_TYPE_PREFIX_BY_TAB: Partial<Record<TMediaGalleryTab, string>> = {
    images: 'image/',
    videos: 'video/',
    audios: 'audio/',
    documents: 'application/',
};

export const buildMediaGalleryMessageFilters = (
    tab: TMediaGalleryTab = 'all',
    {
        page = 1,
        limit = MEDIA_GALLERY_DEFAULT_LIMIT,
    }: {
        page?: number;
        limit?: number;
    } = {}
) => {
    const mimeTypePrefix = MIME_TYPE_PREFIX_BY_TAB[tab];

    return {
        page,
        limit,
        sort: '-createdAt',
        'content.media.0': { exists: true },
        ...(mimeTypePrefix
            ? {
                'content.media.contentType': {
                    $regex: `^${mimeTypePrefix.replace('/', '\\/')}`,
                },
            }
            : {}),
    };
};
